import React, { useCallback } from 'react';

import { connect, ConnectedProps } from 'react-redux';
import { CredentialsEntity } from '../../../../models/credentials';
import { PageView, UserInteractionEvent } from '../../../../models/analytics';
import { ProviderEntity } from '../../../../models/provider';
import { ERR_USER_CANCELLED } from '../../../../utilities/error';
import { setApplicationError as setApplicationErrorConnect } from '../../../../stores/app-state-store';
import { usePageViewEvents } from '../../../../core/Analytics/usePageViewEvents';
import { HandoffCodeScannedView } from './HandoffCodeScannedView';

export type HandoffCodeScannedOwnProps = {
  provider: ProviderEntity;
  credentials?: CredentialsEntity;
  onCancel?: () => void;
  pageView?: PageView;
};

export type HandoffCodeScannedProps = PropsFromRedux & HandoffCodeScannedOwnProps;

export const HandoffCodeScannedPresenter: React.FC<HandoffCodeScannedProps> = ({
  credentials,
  provider,
  onCancel,
  setApplicationError,
  pageView = PageView.HANDOFF_QR_CODE_SCANNED_SCREEN,
}) => {
  const { sendViewInteractionEvent } = usePageViewEvents({ pageView });
  const cancelWithAnalytics = useCallback(() => {
    sendViewInteractionEvent({ interaction: UserInteractionEvent.HANDOFF_CANCELLED });

    if (onCancel) {
      onCancel();
    } else {
      setApplicationError(ERR_USER_CANCELLED);
    }
  }, [onCancel, sendViewInteractionEvent, setApplicationError]);

  return (
    <HandoffCodeScannedView
      credentials={credentials}
      provider={provider}
      onClick={cancelWithAnalytics}
    />
  );
};

const connector = connect(undefined, {
  setApplicationError: setApplicationErrorConnect,
});

type PropsFromRedux = ConnectedProps<typeof connector>;

export const HandoffCodeScanned = connector(HandoffCodeScannedPresenter);
